module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/prospect/telecaller-details/telecaller-details-form/telecaller-details-form.component.css
// module id = ./src/app/prospect/telecaller-details/telecaller-details-form/telecaller-details-form.component.css
// module chunks = main